export const friendlyDate = 'EEEE d MMM yyyy kl HH:mm';
export const friendlyDateTimeWithDayShort = 'EEE d MMM kl HH:mm';
export const friendlyDateTimeShort = 'd MMM kl HH:mm';
export const friendlyDateShort = 'EEEE d MMM yyyy';
